module.exports = __webpack_public_path__ + "img/lenovo.a26ffa8e.png";